import httpcommon from "../services/httpcommon";
import httpcommon1 from "../services/httpCommon1";
import axios from "axios";
import { encryptData } from "../assets/encryptDecrypt";

const API_RESPONSE_CODES = {
  SUCCESS: '200',
  SERVER_ERROR: '500'
};

const USER_ROLES = {
  PRADMIN: 'PRADMIN',
  GROUPPRADMIN: 'GROUPPRADMIN',
  CE: 'CE',
  ACCADMIN: 'ACCADMIN'
};

const SERVICE_TYPE_IDS = {
  IPD: 8,
  OPD: 9,
  INVESTIGATION: 10,
  DAYCARE: 11
};

const BILLING_STATUS = {
  BILLING_UPLOADED: 1,
  BILLING_DONE: 2,
  BILLING_COMPLETED: 3,
  REJECTED: 6
};

class ApiService {
  async makeRequest(config, service = httpcommon1) {
    try {
      const response = await service(config);
      return response;
    } catch (error) {
      console.error('API Request Error:', error);
      return error.response || null;
    }
  }

  filterEmptyValues(obj) {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => 
        value !== undefined && value !== null && value !== ''
      )
    );
  }

  objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
  }

  async getUserConsent() {
    const configurationObject = {
      method: 'GET',
      url: process.env.REACT_APP_CMS_VERSION_URL,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    };
    return this.makeRequest(configurationObject, axios);
  }

  async getToken(formData, OTP) {
    try {
      const { userCode, userMobileNumber, passWord, userOTP } = formData;
      const params = new URLSearchParams();
      params.append('username', userCode || userMobileNumber);

      let passwordValue = OTP;
      if (passWord) {
        passwordValue = btoa(passWord);
      } else if (userOTP) {
        passwordValue = userOTP;
      }

      params.append('password', passwordValue);
      params.append('grant_type', 'password');

      const credentials = 'curebay:cGFzc3dvcmQ=';
      const encodedCredentials = globalThis.btoa(credentials);
      const payload1 = {
        userCode,
        passWord: encodedCredentials,
        channel: 'W'
      };

      const encryptedData = encryptData(JSON.stringify(payload1));

      return await this.makeRequest({
        method: 'POST',
        url: 'authentication/gcp/token',
        data: encryptedData,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'grant_type': 'password',
          'Authorization': `Basic ${encodedCredentials}`
        },
      });
    } catch (error) {
      console.error('Token API Error:', error);
      return null;
    }
  }

  async userInfo(userCode) {
    const params = new URLSearchParams();
    params.append('userId', userCode);
    return this.makeRequest({
      method: 'GET',
      url: `/userHospitalLocation/getByUserId?${params.toString()}`
    });
  }
 async userInfoAll(userCode) {
    const params = new URLSearchParams();
    params.append('userId', userCode);
    return this.makeRequest({
      method: 'GET',
      url: `/userHospitalLocation/getAllByUserId?${params.toString()}`
    });
  }
  async loginApi(formData) {
    const parsedFormData = JSON.parse(formData);
    const filteredFormData = this.filterEmptyValues(parsedFormData);
    
    if (filteredFormData.passWord) {
      filteredFormData.passWord = btoa(filteredFormData.passWord);
      filteredFormData.roleCode = USER_ROLES.PRADMIN;
    }

    const encryptedData = encryptData(JSON.stringify(filteredFormData));
    return this.makeRequest({
      method: 'POST',
      url: 'login/user',
      data: encryptedData
    });
  }

  async getApiCMS(id) {
    const NEW_CMS_TOKEN = 'Bearer 6f1797939dbb00599d8896d29f4e114b257e1e252d6856294951bdcdd7be292b7b49d6a266f2319d74e024cac8a99de3ab5256b82e25d4bb931a5c44a28f8d5ddcdffc51ee8abad8f62ac14a985397c4636b7575a9709d1cd6ae4bed4419494c2ea96ed3bc6223a5bac20e6a07342f7f17fb1cc7c87dccd85c0de0930896afe1';
    
    const configurationObject = {
      method: 'GET',
      url: `${process.env.REACT_APP_USER_CMS_URL}&userId=${id}`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: NEW_CMS_TOKEN,
      },
    };
    return this.makeRequest(configurationObject, axios);
  }

  async userConsentPost(payload) {
    const sToken = localStorage.getItem('access_token');
    const configurationObject = {
      method: 'POST',
      url: process.env.REACT_APP_USER_ADDCONSENT,
      data: payload,
      headers: {
        Authorization: `Bearer ${sToken || ''}`,
      }
    };
    return this.makeRequest(configurationObject, axios);
  }

  async forgetPassword(filterDetails) {
    return this.makeRequest({
      method: 'POST',
      url: 'PasswordMaintenance/forgetpassword/',
      data: filterDetails
    });
  }

  async getenqList(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'enquiry/getEnquiryList',
      data: payload
    });
  }
async exportNewEenqList(payload) {
        try {
            const response = await httpcommon1.post(`api/excel/download/enquiry`, payload, {
                responseType: 'blob',
            });

            if (response) {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = globalThis.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Enquiry_Report.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove(); 
                globalThis.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('API Request Error:', error);
        }
    }
 async exportServiceList(payload) {
        try {
            const response = await httpcommon1.post(`api/excel/download/surgery`, payload, {
                responseType: 'blob',
            });

            if (response) {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = globalThis.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Enquiry_Report.xlsx';
                document.body.appendChild(a);
                a.click();
                a.remove(); 
                globalThis.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('API Request Error:', error);
        }
    }

  async enquiryStatusUpdate(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'confirm/patientReferralBatch',
      data: payload
    });
  }

  async billingApprovalUpdate(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'confirm/surgeryBillingConfirmationBatch',
      data: payload
    });
  }

  async getServicesBillList(payload) {
    return this.makeRequest({
      method: 'POST',
      url: '/surgery/getSurgeryList',
      data: payload
    });
  }

  async getServicesBillListByPatient(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'surgery/billCount',
      data: payload
    });
  }

  async openFilesBucket(fileName) {
    return this.makeRequest({
      method: 'GET',
      url: `document/getDocumentURL/${fileName}`
    });
  }

  async geteServices(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'Services/getList',
      data: payload
    });
  }

  async getMdmUserlist(payload) {
    return this.makeRequest({
      method: 'POST',
      url: '/dropdown/surgeryDoctorlist',
      data: payload
    });
  }

  async dashBoardCount(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'dashboard/enquiryStatusCount',
      data: payload
    });
  }

  async billigstatusCount(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'dashboard/billingStatusCount',
      data: payload
    });
  }

  async saveService(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'surgery/saveServiceDetails',
      data: payload
    });
  }

  async calculateService(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'surgery/calculateServiceDetails',
      data: payload
    });
  }

  async getDoctorList2(payload) {
    const queryString = this.objectToQueryString(payload);
    return this.makeRequest({
      method: 'GET',
      url: `user/list/filter?${queryString}`
    });
  }

  async getHospitaliztionList(payload) {
    const queryString = this.objectToQueryString(payload);
    return this.makeRequest({
      method: 'GET',
      url: `${process.env.REACT_APP_NEW_BASEURL}hospitalizationServiceType/list/filter?${queryString}`,
      service: httpcommon
    });
  }

  async getHospitalList() {
    return this.makeRequest({
      method: 'POST',
      url: 'dropdown/location/list',
      data: {}
    });
  }

  async getUserList(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'dropdown/user/roleCode',
      data: payload
    });
  }

  async updateInsurence(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `enquiry/updateInsuranceDetails/${payload.id}`,
      data: payload
    });
  }
  async feedbackSubmit(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `patientFeedback/create/${payload.feedbackId}`,
      data: payload
    });
  }
  async updateSevice(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `enquiry/updateServiceDetails/${payload.id}`,
      data: payload
    });
  }

  async updateConsent(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `document/uploadConsentForm/${payload.id}`,
      data: payload
    });
  }

  async updateBill(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `/document/uploadBill/${payload.id}`,
      data: payload
    });
  }

  async uploadReports(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `/document/uploadReport/${payload[0].id}`,
      data: payload
    });
  }

  async approvefromFinance(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: 'approval/financeApproval/',
      data: payload
    });
  }

  async rejectfromFinance(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: 'approval/financeReject/',
      data: payload
    });
  }

  async apporoveOthers(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: 'approval/adminApproval/',
      data: payload
    });
  }

  async updateDischarge(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `document/uploadDischargeSummary/${payload.id}`,
      data: payload
    });
  }

  async getEnquiryById(payload) {
    const queryString = this.objectToQueryString(payload);
    return this.makeRequest({
      method: 'GET',
      url: `enquiry/getEnquiryById?${queryString}`
    });
  }

  async getPatientFeedbackInfo(payload) {
    return this.makeRequest({
      method: 'GET',
      url: `patientFeedback/patientDetails/${payload}`
    });
  }

  async geFeedbackList(payload) {
    return this.makeRequest({
      method: 'POST',
      url: `/dashboard/feedbackList`,
      data: payload
    });
  }

  async getFeedbackCount(payload) {
    return this.makeRequest({
      method: 'POST',
      url: `/dashboard/feedbackCount`,
      data: payload
    });
  }

  async getPatientName(payload) {
    const queryString = this.objectToQueryString(payload);
    return this.makeRequest({
      method: 'GET',
      url: `patientDetail/getName?${queryString}`
    });
  }

  async attendanceTracking(payload) {
    const queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
    try {
      const isExport = payload.export === true;
      const config = isExport ? { responseType: 'blob' } : {};

      const response = await httpcommon1.get(`agentReport/attendanceSummary?${queryString}`, config);
      if (response) {
        if (isExport) {
          return {
            data: response.data,
            headers: response.headers
          };
        }
        return response;
      }
    } catch (error) {
      console.error('API Request Error:', error);
      return null;
    }
  }

  async hospitalVisitTrackingXL(payload) {
    const queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");
    try {
      const config = { responseType: 'blob' };

      const response = await httpcommon1.get(`/agentReport/attendance/ceReport/export?${queryString}`, config);
      if (response) {
        return response;
      }
    } catch (error) {
      console.error('API Request Error:', error);
      return null;
    }
  }

  async realTimeTracking(payload) {
    try {
      const queryString = Object.keys(payload)
        .map((key) => `${key}=${payload[key]}`)
        .join("&");

      const isExport = payload.export === true;
      const config = isExport ? { responseType: 'blob' } : {};

      const response = await httpcommon1.get(`agentReport/enquiry-report?${queryString}`, config);

      if (response) {
        if (isExport) {
          return {
            data: response.data,
            headers: response.headers
          };
        }
        return response;
      }
    } catch (error) {
      console.error('API Request Error:', error);
      return null;
    }
  }

  async hospitalVisitTracking(payload) {
    const queryString = this.objectToQueryString(payload);
    const config = {};
    
    return this.makeRequest({
      method: 'GET',
      url: `agentReport/attendance/ceReport?${queryString}`,
      ...config
    });
  }

  async patientSave(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'patientDetail/updateName',
      data: payload
    });
  }

  async getFeedback(payload, enqId) {
    return this.makeRequest({
      method: 'POST',
      url: `/patientFeedback/notification/${enqId}`,
      data: payload
    });
  }
  
  async submitFeedback(payload) {
    return this.makeRequest({
      method: 'POST',
      url: `patientFeedback/create/${payload}`,
      data: payload
    });
  }

  async updateConceirge(payload) {
    return this.makeRequest({
      method: 'PUT',
      url: `enquiry/updateConsentDetails/${payload.id}`,
      data: payload
    });
  }

  async updateAssidgn(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'enquiry-role/assign',
      data: payload
    });
  }

  async patientReferalApproval(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'confirm/patientReferral',
      data: payload
    });
  }

  async traumaApproval(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'confirm/traumaApproval',
      data: payload
    });
  }

  async financeApproval(payload) {
    return this.makeRequest({
      method: 'POST',
      url: 'confirm/surgeryBillingConfirmation',
      data: payload
    });
  }

  async getApproval(payload, id) {
    return this.makeRequest({
      method: 'PUT',
      url: `approval/approveEnquiryForm/${id}`,
      data: payload
    });
  }

  async downloadHospitalDetails() {
    try {
      const response = await httpcommon1.get(`/api/excel/hospital-onboard`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Error downloading hospital details:', error);
      throw error;
    }
  }

  async downloadSurgeryConsents(payload) {
    try {
      const response = await httpcommon1.get(`/api/excel/surgery-consent?fromDate=${payload.fromDate}&toDate=${payload.toDate}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Error downloading surgery consents:', error);
      throw error;
    }
  }

  async downloadDischargeSummary(payload) {
    try {
      const response = await httpcommon1.get(`/api/excel/discharge-summary?fromDate=${payload.fromDate}&toDate=${payload.toDate}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Error downloading discharge summary:', error);
      throw error;
    }
  }

  async downloadFile(url, payload, filename) {
    try {
      const response = await httpcommon1.post(url, payload, {
        responseType: 'blob',
      });

      if (response) {
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const downloadUrl = globalThis.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.remove();
        globalThis.URL.revokeObjectURL(downloadUrl);
      }
    } catch (error) {
      console.error('Download Error:', error);
      throw error;
    }
  }
}

const apiService = new ApiService();
export default apiService;